import { PaymentOrigin } from '../../hooks/usePaymentOrigin';

/** Notas del origen que no son de un campo: sitio sin cajas, o no se pudieron cargar. */
export default function PaymentOriginNote({ origin }: { origin: PaymentOrigin }) {
    if (origin.cashRegistersStatus === 'loaded' && !origin.requiresPaymentOrigin) {
        return <p className="md-help">Este sitio no maneja cajas: el pago se registra sin movimiento de caja ni de cuenta financiera.</p>;
    }
    if (origin.cashRegistersStatus === 'error') {
        return <p className="md-help">No se pudieron cargar las cajas, así que no se puede registrar el pago. Volvé a abrir el pago para reintentar.</p>;
    }
    return null;
}
